import axiosInstance from "../utils/axiosInstance";

export const searchWorkersApi = async (args) =>
  await axiosInstance.post("/worker", { findArgs: args });

export const getAdminPatientsApi = async (params) =>
  await axiosInstance.get(`/admin/patient/`, { params });

export const getAdminWorkersByUnitApi = async (unit) =>
  await axiosInstance.get(`/admin/worker${unit ? `?unit=${unit}` : ""}`);

export const getAdminAppointmentsApi = async (params) =>
  await axiosInstance.get(`/admin/appointment/`, { params });

export const getAdminRequestFormsApi = async (params) =>
  await axiosInstance.get(`/admin/request-forms`, { params });

export const getAdminAuditLogsApi = async (params) =>
  await axiosInstance.get(`/admin/audit-logs`, { params });

export const fetchStatsApi = async () =>
  await axiosInstance.get(`/admin/stats/`);

export const updateWorkerRoleApi = async ({ workerId, role }) =>
  await axiosInstance.patch(`/admin/worker/${workerId}/role`, { role });

export const getRoleCatalogApi = async () =>
  await axiosInstance.get("/admin/roles");
